import { observer } from 'mobx-react'
import styles from './BaseModal.module.less'
import { Modal } from 'antd'
import type { GetProps } from 'antd'
import { IconImage } from '../Icon'

type ModalProps = GetProps<typeof Modal>

export interface BaseModalProps extends ModalProps {
  borderRadius?: number
}

const BaseModal = observer((props: BaseModalProps) => {
  const { borderRadius = 8, title, children, footer, ...restProps } = props
  return (
    <Modal
      open={props.open}
      footer={null}
      closeIcon={false}
      width={853}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: borderRadius,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
      {...restProps}
    >
      <div
        className={styles.baseModal}
        style={{
          width: props.width as string | number,
          borderRadius: borderRadius,
        }}
      >
        <div className={styles.modalClose} onClick={props.onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        {title && <div className={styles.modalTitle}>{title}</div>}
        <div className={styles.modalContent}>{children}</div>
        {footer ? (
          typeof footer === 'function' ? (
            footer(null, {
              OkBtn: () => <div className={styles.confirmBtn}>{props.okText || '确定'}</div>,
              CancelBtn: () => <div className={styles.cancelBtn}>{props.cancelText || '取消'}</div>,
            })
          ) : (
            footer
          )
        ) : (
          <div className={styles.modalFooter}>
            <button className={styles.cancelBtn} onClick={props.onClose}>
              {props.cancelText || '取消'}
            </button>
            <button className={styles.confirmBtn} onClick={props.onOk}>
              {props.okText || '确定'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
})

export default BaseModal
